import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { toggleSidenav } from '../actions';

const Sidenav = ({ authenticated, sidenav, toggleSidenav }) => {
  const { pathname } = useLocation();

  const handleToggle = useCallback(() => {
    toggleSidenav(!sidenav);
  }, [sidenav, toggleSidenav]);

  const renderLinks = useCallback(() => {
    const authedLinks = [
      { link: '/order-list', desc: 'Order' },
      { link: '/delivery-list', desc: 'Delivery' },
      { link: '/report-search', desc: 'Report' },
      { link: '/remake-list', desc: 'Remake' },
      { link: '/remake-report', desc: 'Remake Report' },
      { link: '/tip-report', desc: 'Tip Report' },
      { link: '/throughput-report', desc: 'Throughput Report' },
      { link: '/signout', desc: 'Sign Out' },
    ];

    if (authenticated) {
      let key = 1;

      return authedLinks.map(({ link, desc }) => {
        return (
          <li key={key++} className={pathname === link ? 'active-nav' : ''}>
            <Link onClick={handleToggle} to={link}>
              {desc}
            </Link>
          </li>
        );
      });
    } else {
      return (
        <li>
          <Link key="0" to="/signin" onClick={handleToggle}>
            Sign In
          </Link>
        </li>
      );
    }
  }, [authenticated, handleToggle, pathname]);

  return (
    <div>
      <div
        className="sidenav-overlay"
        onClick={handleToggle}
        style={
          sidenav
            ? {
                display: 'block',
                zIndex: 999,
                opacity: 1,
                visibility: 'visible',
                transition: 'opacity 0.5s visibility 0.5s',
              }
            : {
                display: 'none',
                opacity: 0,
                visibility: 'hidden',
                transition: 'opacity 0.5s visibility 0.5s',
              }
        }
      />
      <ul
        className="sidenav"
        onClick={handleToggle}
        style={
          sidenav
            ? { transform: 'translateX(0%)', transition: '0.5s' }
            : { transform: 'translateX(-105%)', transition: '0.5s' }
        }
      >
        {renderLinks()}
      </ul>
    </div>
  );
};

function mapStateToProps(state) {
  return { authenticated: state.auth.authenticated, sidenav: state.sidenav };
}

export default connect(mapStateToProps, { toggleSidenav })(Sidenav);
